import React, {Component} from 'react';
import {API_BASE_URL} from '../../resources/constant';

export default class ViewCreditNoticeFile extends Component{      

    constructor(props){
        super(props);
        
        var merchId = localStorage.getItem("MerchId");
        var uplDate = localStorage.getItem("UploadDate");
        this.state = {
            URL:API_BASE_URL +"cad/merchant/getMerchCreditNotice?merchId="+this.props.SingleId+"&upldDate="+this.props.UploadDate,
            MerchId:merchId,
            UplDate:uplDate
        }
        
    }
    
    componentDidMount() {    
        var merchId = localStorage.getItem("MerchId");
        var uplDate = localStorage.getItem("UploadDate");

        this.setState({
            MerchId:merchId,
            UplDate:uplDate
        })     
        window.addEventListener("beforeunload", this.onUnload)
      }
    componentWillUnmount(){    
        window.removeEventListener("beforeunload", this.onUnload)    
        
    }
    onUnload(event) { // the method that will be used for both add and remove event
        
        localStorage.removeItem("MerchId");
        localStorage.removeItem("UploadDate");  
        
        // event.returnValue = "test"
      }

    render(){                  
        return(                   
            <div>
                <div style={{background:'#0B2972', height:"30px"}}>
                    <div align="center">
                    <span style={{color:'#FFFFFF', textAlign:'center'}} >
                        <font style={{color:'#FFFFFF', size:'2'}}>
                            CREDIT NOTICE 
                            {/* {this.state.URL} */}
                        </font>
                    </span>
                    </div>
                </div>

                <div> 
                    <object width="100%" height="650px" data={API_BASE_URL +"cad/merchant/getMerchCreditNotice?merchId="+this.state.MerchId+"&upldDate="+this.state.UplDate} type="application/pdf">
                        {/*<embed  src={API_BASE_URL +"cad/merchant/getMerchCreditNotice?merchId="+this.state.MerchId+"&upldDate="+this.state.UplDate+".pdf"} type="application/pdf" />*/}
                    </object>   
                </div>
            </div>
        )
    }
}

